import { Button, Flex } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import SwitchField from '../../shared/ui/forms/SwitchField';
import translation from './lib/translations';

const Settings: FC<{ onSave: () => void; isOpen: boolean }> = ({ onSave, isOpen }) => {
  const { i18n } = useTranslation();
  const t = translation(i18n.language);

  return (
    <Flex
      bg='bg.light'
      borderRadius='md'
      color='gray.dark'
      display={isOpen ? 'flex' : 'none'}
      flexDir='column'
      gap='sm'
      p={{ base: 'md', md: 'lg' }}
      w='full'
    >
      <SwitchField
        fontWeight='semibold'
        helperText={t.necessaryText}
        isDisabled
        label={t.necessary}
        name='necessary'
      />
      <SwitchField
        fontWeight='semibold'
        helperText={t.analyticsText}
        label={t.analytics}
        name='analytics_storage'
      />
      <SwitchField
        fontWeight='semibold'
        helperText={t.adStorageText}
        label={t.adStorage}
        name='ad_storage'
      />
      <SwitchField
        fontWeight='semibold'
        helperText={t.personalizationText}
        label={t.personalization}
        name='ad_personalization'
      />
      <SwitchField
        fontWeight='semibold'
        helperText={t.userDataText}
        label={t.userData}
        name='ad_user_data'
      />
      <Button
        colorScheme='primary'
        variant='outline'
        w='fit-content'
        onClick={onSave}
      >
        {t.saveBtn}
      </Button>
    </Flex>
  );
};

export default Settings;
